import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_SHIP_FARE}`;

/** 取得運費 + 實付金額 */
export default (param) => axios.get(API_PATH, { params: param });
